import { useServicesContext } from "@modules/core/services/services.context"
import { HomeContent } from "@modules/home/entities/homeEntity"
import { useLanguage } from "@modules/language/hooks/useLanguage"
import { useQuery } from "@tanstack/react-query"

export const useHome = () => {
  const { homeApi } = useServicesContext()
  const language = useLanguage()

  const { data } = useQuery({
    queryKey: ["home", language],
    staleTime: 1000 * 60 * 60 * 24,
    queryFn: async () => {
      const homeContentDto = await homeApi.getHomeContent(language)
      return homeContentDto ? HomeContent.fromDto(homeContentDto) : null
    },
  })

  return {
    homeContent: data,
  }
}
